import { useScreenId } from '@muse-web/router'
import { ScreenId } from '@core/router'

// Mirrored by backend-audio `AppShell::hasChrome()`.
const CHROMELESS: ScreenId[] = [ScreenId.AUTH, ScreenId.FORGOT_PASSWORD, ScreenId.ERROR]

let initialScreenId = ''

/**
 * The router reports an empty screen id until the first screen commits, and an unknown screen is
 * not chromeless — so without this the chrome renders for a frame on every chromeless screen.
 */
export const setInitialScreen = (screenId: string) => {
    initialScreenId = screenId
}

export const isChromelessScreen = (screenId: string): boolean =>
    CHROMELESS.some(chromeless => chromeless === screenId)

export const useIsChromeless = (): boolean => {
    const screenId = useScreenId<ScreenId>() || initialScreenId

    return isChromelessScreen(screenId)
}
